export default {
  listCloudBackups: true,
  ubiquitiAccount: '',
  ubiquitiPassword: '',
  ubiquiti2faTokenRequired: false,
  ubiquiti2faToken: undefined,
};
